import { IconButton } from '@mui/material';
import { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import SearchBox from '../SearchBox';
import { useTheme } from '../../providers/ThemeProvider';

export default function SearchEmblem() {
  const [search, setSearch] = useState<boolean>(false);
  const { colors } = useTheme();

  return (
    <>
      <IconButton sx={{ mr: 0.5 }} onClick={() => setSearch(true)}>
        <SearchIcon sx={{ color: colors.text }} />
      </IconButton>

      <SearchBox open={search} setShow={() => setSearch(false)} />
    </>
  );
}
